import React from 'react';
export function Summary({
  cart,
  pricingData,
  priceType,
  total,
  onClearCart
}) {
  return <div className="mb-8 border-t border-b py-6" data-id="element-208">
      <div className="flex justify-between items-center mb-4" data-id="element-209">
        <h2 className="text-2xl font-bold text-blue-900" data-id="element-210">Quote Summary</h2>
        <button className="px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700" onClick={onClearCart} data-id="element-211">
          START OVER
        </button>
      </div>
      <div className="overflow-x-auto" data-id="element-212">
        <table className="min-w-full bg-white border" data-id="element-213">
          <thead data-id="element-214">
            <tr className="bg-gray-100" data-id="element-215">
              <th className="py-2 px-4 border text-left" data-id="element-216">Item</th>
              <th className="py-2 px-4 border text-right" data-id="element-217">Price</th>
              <th className="py-2 px-4 border text-center" data-id="element-218">Quantity</th>
              <th className="py-2 px-4 border text-right" data-id="element-219">Subtotal</th>
            </tr>
          </thead>
          <tbody data-id="element-220">
            {Object.entries(cart).map(([itemId, quantity]) => {
            const item = pricingData.find(p => p.id === itemId);
            if (!item) return null;
            const price = item[priceType];
            const subtotal = price * quantity;
            return <tr key={itemId} data-id="element-221">
                  <td className="py-2 px-4 border" data-id="element-222">
                    <div className="font-medium" data-id="element-223">{item.name}</div>
                    {item.description && <div className="text-sm text-gray-600" data-id="element-224">
                        {item.description}
                      </div>}
                  </td>
                  <td className="py-2 px-4 border text-right" data-id="element-225">
                    ${price.toFixed(2)}
                  </td>
                  <td className="py-2 px-4 border text-center" data-id="element-226">{quantity}</td>
                  <td className="py-2 px-4 border text-right" data-id="element-227">
                    ${subtotal.toFixed(2)}
                  </td>
                </tr>;
          })}
          </tbody>
          <tfoot data-id="element-228">
            <tr className="bg-gray-100" data-id="element-229">
              <td colSpan={3} className="py-2 px-4 border text-right font-bold" data-id="element-230">
                Total:
              </td>
              <td className="py-2 px-4 border text-right font-bold" data-id="element-231">
                ${total}
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>;
}